import { fr } from "vuetify/src/locale";

export default {
  ...fr,
  user: "Utilisateur",
  password: "Mot de passe",
  language: "Langue",
  submit: "Se connecter",
  theme: "Thème",
  sessionExits:
    "Il existe déjà une session avec ce nom d'utilisateur. Souhaitez-vous quand même vous inscrire et détruire la session précédente ?",
  sessionKill: "Supprimer la séance",
  wrongAuth: "Mauvais utilisateur ou mot de passe",
  userDateExpired: "La licence utilisateur est expirée",
  dateExpired: "La licence a expiré",
  userNoRole: "L'utilisateur n'a pas de rôle",
  userNoAccess: "L'utilisateur n'a aucune autorisation pour le concepteur",
  sessionExpired: "La session a expiré",
  release: "Libérer",
  autologin: "Connexion automatique",
  blue: "Blue",
  dark: "Darkmode",
  material: "Material",
  quartz: "Quartz",
  horizon: "Horizon",
  client: "Client",
};
